import { makeStyles, tokens } from '@fluentui/react-components';
import { vt } from '../../theme';

export interface BarItem {
  key: string;
  label: string;
  value: number;
  /** The value as shown, "4.2 GB". */
  text: string;
  color: string;
}

const useStyles = makeStyles({
  list: { listStyleType: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column' },
  row: {
    display: 'grid',
    gridTemplateColumns: '8px 140px minmax(0, 1fr) 72px',
    columnGap: '10px',
    alignItems: 'center',
    height: '28px',
  },
  dot: { width: '7px', height: '7px', borderRadius: '50%' },
  label: { color: vt.fg1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  track: { height: '6px', borderRadius: '3px', backgroundColor: vt.tintNeutral, overflow: 'hidden' },
  bar: { display: 'block', height: '100%', borderRadius: '3px' },
  value: { fontFamily: tokens.fontFamilyMonospace, fontSize: '11.5px', color: vt.fg2, textAlign: 'end' },
  empty: { color: vt.fg3, paddingBlock: '8px' },
});

/** Mockup 06's top talkers: a bar per item, scaled to the largest, the comparison being the content. */
export function BarList({ items, label, empty }: { items: BarItem[]; label: string; empty: string }) {
  const s = useStyles();
  const max = Math.max(0, ...items.map((i) => i.value));
  if (items.length === 0) return <div className={s.empty}>{empty}</div>;
  return (
    <ul className={s.list} aria-label={label}>
      {items.map((i) => (
        <li key={i.key} className={s.row} data-key={i.key}>
          <span className={s.dot} style={{ backgroundColor: i.color }} aria-hidden />
          <span className={s.label}>{i.label}</span>
          <span className={s.track} aria-hidden>
            <span
              className={s.bar}
              style={{ width: `${max > 0 ? (i.value / max) * 100 : 0}%`, backgroundColor: i.color }}
            />
          </span>
          <span className={s.value}>{i.text}</span>
        </li>
      ))}
    </ul>
  );
}
